import { FC, ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface Props {
  h2: string;
  paragraph: any;
  animation: ReactNode;
}

const Service: FC<Props> = ({ h2, paragraph, animation }) => {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });

  return (
    <div
      ref={ref}
      className="w-full md:mx-2 mb-4 rounded bg-[#0D375B] py-5 px-2 md:px-4"
    >
      <div className="relative w-fit h-fit flex justify-center mx-auto py-2 mb-5">
        <div className="relative w-[173px] h-[173px] rounded-full bg-[#182A3B]"></div>
        {animation}
      </div>

      <div className="text-white text-center">
        <motion.h2
          className="pb-5 text-p2Semibold"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          viewport={{ amount: 0.5, once: true }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          {h2}
        </motion.h2>

        <motion.p
          className="text-p3Regular text-white"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          viewport={{ amount: 0.5, once: true }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {paragraph}
        </motion.p>
      </div>
    </div>
  );
};

export default Service;
